import { Injectable } from '@angular/core';
import { EducationalProvider, Program } from '@edassist/api';

@Injectable({ providedIn: 'root' })
export class EducationProviderUtilityService {
	static showIneligibleProviderWarning(
		program: Program,
		educationalProvider: EducationalProvider
	): boolean {
		const isMatchingAccredidationCollections =
			program.programAccreditingBodyCollection?.filter((accreditingBody) => {
				const accreditingBodyId = accreditingBody.accreditingBody.id;

				return educationalProvider.providerAccreditationCollection.some(
					(providerAccreditiation) =>
						providerAccreditiation.accreditingBody.id === accreditingBodyId
				);
			}).length > 0;

		return (
			program.warnIneligibleAccredition && !isMatchingAccredidationCollections
		);
	}
}
